import { userGridItemFrag } from '../../../../../services/types/user.types';

export const personContactFrag = `
    id
    user {
        ${userGridItemFrag}
    }
    subType
    validFrom
    validTo
    note
    data {
        basis
        referenceNumber
        isRelative
        municipality
    }
`;
